import { AppSettingsVar } from '../../../_project/settings';

/**
 * Join API base URL with a path segment (handles missing slashes).
 * Used for form actions and /rest/upload/ etc.
 */
export function joinApiBaseUrl(path) {
  const base = (AppSettingsVar.base_url || '').replace(/\/?$/, '/');
  const p = String(path || '').replace(/^\//, '');
  return base + p;
}

/**
 * Same resolution as use-form sendRequest: absolute URLs unchanged; otherwise prefix base_url.
 */
export function resolveRestUrl(url) {
  if (!url) return url;
  const s = url.toString();
  if (s.startsWith('http://') || s.startsWith('https://')) {
    return s;
  }
  if (s.startsWith('/')) {
    return joinApiBaseUrl(s.slice(1));
  }
  return joinApiBaseUrl(s);
}
